import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenuItem = _resolveComponent("ContextMenuItem")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createBlock(_component_ContextMenu, {
    isVisible: _ctx.isVisible,
    position: _ctx.position,
    onClose: _ctx.handleClose,
    class: "global-context-menu-products"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleSelectProductsGroups }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("Товарные группы", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_ContextMenuItem, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleAction(2)))
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("на 2 знаках", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_ContextMenuItem, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAction(4)))
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("на 4 знаках", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_ContextMenuItem, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAction(6)))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("на 6 знаках", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_ContextMenuItem, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleAction(8)))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("на 8 знаках", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_ContextMenuItem, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAction(9)))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
          _createTextVNode("на 9 знаках", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_ContextMenuItem, {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleAction(10)))
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
          _createTextVNode("на 10 знаках", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["isVisible", "position", "onClose"]))
}